export const GET_FAVORITES = "GET_FAVORITES";
export const ADD_TO_FAVORITE = "ADD_TO_FAVORITE";
export const REMOVE_FROM_FAVORITE = "REMOVE_FROM_FAVORITE";
export const FILTER_FAVORITE = "FILTER_FAVORITE";
export const CLEAR_FILTER = "CLEAR_FILTER";
